class ReferenceStickyHeader extends HTMLElement {
  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.header = this.closest('.section-header');
    if (!this.header) return;

    this.header.classList.toggle('ck-header-section--overlay', this.classList.contains('ck-header-wrapper--overlay'));

    this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearches = this.querySelectorAll('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.setHeaderHeight();
    this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }

  setHeaderHeight() {
    if (this.header) {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if ([...this.predictiveSearches].some((search) => search.isOpen)) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) requestAnimationFrame(() => this.hide());
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = window.setTimeout(() => (this.preventReveal = false), 66);
        requestAnimationFrame(() => this.hide());
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
    this.searchModals.forEach((searchModal) => searchModal.close(false));
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', ReferenceStickyHeader);
}

document.addEventListener(
  'open',
  (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  },
  true
);

function updateReferenceHeader() {
  const announcement = document.querySelector('.announcement-bar-section:has(.ck-utility-bar)');
  const root = document.documentElement;
  const isCompact = window.matchMedia('(max-width: 989px)').matches;
  root.style.setProperty('--ck-announcement-height', announcement && !isCompact ? `${announcement.offsetHeight}px` : '0px');

  document.querySelectorAll('.ck-country-flag[data-country-code]').forEach((flag) => {
    const code = flag.dataset.countryCode?.toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return;
    flag.textContent = [...code].map((letter) => String.fromCodePoint(letter.charCodeAt(0) + 127397)).join('');
  });
}

document.addEventListener('click', (event) => {
  const closeButton = event.target instanceof Element ? event.target.closest('[data-ck-close-drawer]') : null;
  if (!closeButton) return;
  closeButton.closest('menu-drawer')?.querySelector('summary.header__icon--menu')?.click();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateReferenceHeader);
} else {
  updateReferenceHeader();
}
document.addEventListener('shopify:section:load', updateReferenceHeader);
window.addEventListener('resize', updateReferenceHeader);
